import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as Admin from "../store/ducks/admin.duck";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Grid } from '@material-ui/core';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../../_metronic/_assets/css/app2.css';
// import { Editor } from '@tinymce/tinymce-react';
// import { makeStyles } from '@material-ui/core';

export default function ProviderProgramBio(props) {
    
  const dispatch = useDispatch()
  const providerProgram = useSelector(state => state.admin.ProgramProviderBio)
  var [providerBio,setProviderBio] = useState(providerProgram.programbio)
  


  function addProviderBIO() {
    // Update BIO 
    dispatch(Admin.actions.putProviderProgramBio({ id: providerProgram.id, bio: providerBio }));
    props.onCloseCustomBio();
  }

  return(
    <Grid item md={12}>  
      <Row>
        <Col md="12" className="quill-field">
          <Form.Group >
            <Form.Label>Custom Bio for Program - {providerProgram && providerProgram.name}</Form.Label>
            <ReactQuill 
                theme="snow"
                value={providerBio || providerProgram.programbio}
                onChange={setProviderBio} 
              />
              {/* <Editor apiKey='wnbo4skoom9pnqmbfdjvwn8xdl1nfjtwhc2ofsqb1myqn5lo'
                value={providerBio || providerProgram.programbio}
                onEditorChange={(newValue, editor)=>setProviderBio(newValue)}
                init={{ branding: false, statusbar: false, height: 500 }}
              /> */}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <Grid container spacing={0} padding={6} justifyContent="space-between">
            <Button variant="light" onClick={()=>props.onCloseCustomBio()}>
              Cancel
            </Button>
            <Button variant="success" size="sm" onClick={() => addProviderBIO()}>
              Save
            </Button>
          </Grid>
        </Col>
      </Row>
    </Grid>
  )


}
  
